// Fields

export const FIELD_COUNTRY_MAX_UK = 32;
export const FIELD_COUNTRY_MAX_FR = 32;
